import { render, staticRenderFns } from "./IssueRiskScoreTableCell.vue?vue&type=template&id=cd0dd264&scoped=true"
import script from "./IssueRiskScoreTableCell.vue?vue&type=script&lang=js"
export * from "./IssueRiskScoreTableCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0dd264",
  null
  
)

export default component.exports